import React from "react";
import { useTheme } from "@mui/material";
import { CustomButton, ButtonType } from "@BehpardazBarin/frontend_components";

type CustomButtonProps = React.ComponentProps<typeof CustomButton>;

export const PrimaryCustomButton: React.FC<CustomButtonProps> = (props) => {
  const theme = useTheme();

  const { textStyle, customButtonStyle, buttonType, ...rest } = props;

  const defaultTextStyle = {
    ...theme.typography.labelMedium,
    color: theme.palette.primary.contrastText,
  };

  const defaultCustomStyle = {
    color: theme.palette.primary.contrastText,
    background: theme.palette.primary.main,
  };

  return (
    <CustomButton
      buttonType={buttonType || ButtonType.smallPrimaryDark}
      textStyle={{ ...defaultTextStyle, ...textStyle }}
      customButtonStyle={{ ...defaultCustomStyle, ...customButtonStyle }}
      {...rest}
    />
  );
};
